export const callPriorities = [
    {
        items: [
            {
                id:   1,
                name: 'High'
            },
            {
                id:   2,
                name: 'Medium'
            },
            {
                id:   3,
                name: 'Low'
            }
        ],
        name:      'Priority',
        itemProps: {
            type: 'priority'
        }
    }
];
